import React from 'react';
import { Pencil } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '../ui/dialog';
import { ContactFormFields } from './ContactFormFields';
import { TagSelector } from '../TagManager';

export const EditContactDialog = ({
  open,
  onOpenChange,
  contactData,
  onContactDataChange,
  onSave,
  saving,
  tags = []
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <Pencil className="w-5 h-5" />
            Edit Contact
          </DialogTitle>
          <DialogDescription>
            Update the contact information. Only email is required.
          </DialogDescription>
        </DialogHeader>
        
        <ContactFormFields 
          data={contactData} 
          onChange={onContactDataChange}
          prefix="edit"
        />
        
        {/* Tags Section */}
        <div className="space-y-2">
          <Label className="text-sm font-medium">Tags</Label>
          <TagSelector
            selectedTags={contactData.tags || []}
            onTagsChange={(newTags) => onContactDataChange({ ...contactData, tags: newTags })}
            availableTags={tags}
          />
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={onSave}
            disabled={saving || !contactData.email}
            className="bg-blue-600 hover:bg-blue-700"
            data-testid="update-contact-btn"
          >
            {saving ? (
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Saving...
              </span>
            ) : (
              "Update Contact"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditContactDialog;
